// @src/pages/NotFound.jsx
const NotFound = () => (
    <div style={{ 
        display: "flex", 
        alignItems: "center",
        flexDirection: "column", 
        justifyContent: "center",
        height: "100vh"  
        }}>
        <img src='/assets/logo.png' alt="Iguana GIFT" />
      <h1>404 Not Found page</h1>
      <p>The page you tried to access doesn't exist.</p>
      <p>This is a generic route.</p>
    </div>
  );
  export default NotFound;